import React, { useState, useEffect } from 'react';
import './ScrollToTop.css';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    const scrolled = document.documentElement.scrollTop;
    const maxHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const progress = (scrolled / maxHeight) * 100;
    
    setScrollProgress(progress);
    
    if (scrolled > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set up scroll listener
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Smooth scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <button
          className="scroll-to-top"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          title="Scroll to top"
        >
          {/* Progress circle */}
          <svg className="progress-ring" width="50" height="50">
            <circle
              className="progress-ring-circle"
              stroke="rgba(102, 126, 234, 0.2)"
              strokeWidth="2"
              fill="transparent"
              r="20"
              cx="25"
              cy="25"
            />
            <circle
              className="progress-ring-progress"
              stroke="#667eea"
              strokeWidth="2"
              fill="transparent"
              r="20"
              cx="25"
              cy="25"
              style={{
                strokeDasharray: `${2 * Math.PI * 20}`,
                strokeDashoffset: `${2 * Math.PI * 20 * (1 - scrollProgress / 100)}`,
              }}
            />
          </svg>
          
          {/* Arrow icon */}
          <svg className="arrow-icon" width="20" height="20" viewBox="0 0 20 20">
            <path
              d="M10 4L6 8h2.5v8h3V8H14l-4-4z"
              fill="currentColor"
            />
          </svg>
        </button>
      )}
    </>
  );
};

export default ScrollToTop;